import type * as React from 'react';

import type { PageSection } from './schema';

/** EAA-2063: inner padding for a section that paints its own background. */
export const PAGE_SECTION_BOX_PADDING = '0.75rem 1rem';

/**
 * EAA-2063: a section is part of the page's one card, not a box of its own. A section that
 * sets a background colour still gets consistent inner padding (it used to paint a box with
 * its text flush against the edges); a white/transparent background is the card's own, so it
 * is not painted again as a separate white-on-grey box.
 */
export function buildSectionStyle(settings: PageSection['settings']): React.CSSProperties {
    const bg = settings?.backgroundColor?.trim();
    const paintsBox = Boolean(bg) && !isCardBackground(bg as string);
    return {
        ...(paintsBox ? { backgroundColor: bg, borderRadius: '0.5rem' } : {}),
        padding: settings?.padding ?? (paintsBox ? PAGE_SECTION_BOX_PADDING : undefined),
        margin: settings?.margin,
    };
}

function isCardBackground(color: string): boolean {
    const c = color.replace(/\s+/g, '').toLowerCase();
    return (
        c === 'transparent' ||
        c === 'white' ||
        c === '#fff' ||
        c === '#ffffff' ||
        c === 'rgb(255,255,255)' ||
        c === 'rgba(255,255,255,1)' ||
        c === 'hsl(var(--card))' ||
        c === 'hsl(var(--background))'
    );
}
